import React, { useState, useEffect, useReducer, useRef } from 'react';
import { helpHttp } from '../../helpers/helpHttp';
import { BASE_API } from '../../api/Globals';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import { InputText } from 'primereact/inputtext';
import { Toolbar } from 'primereact/toolbar';
import { Tag } from 'primereact/tag';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import EditCiclo from './edit';
import { InputSwitch } from 'primereact/inputswitch';
import { Toast } from 'primereact/toast';
import { storage } from '../../helpers/storage';

import Menu from '../../components/sturtural/Menu';
import { Tooltip } from 'primereact/tooltip';


const ListaCiclos = () => {

    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [loadingBorrado, setLoadingBorrado] = useState(false);
    const [loadingSubmit, setLoadingSubmit] = useState({ loading: false, id: 0 });
    const [getUsuarios, setUsuarios] = useState([]);
    const [filters1, setFilters1] = useState(null);
    const [globalFilterValue1, setGlobalFilterValue1] = useState('');
    const [getDisplayBasic, setDisplayBasic] = useState(false);

    const [getEditModal, setEditModal] = useState(false);
    const [getUser, setUser] = useState(null);
    const [checked, setChecked] = useState(false);
    const [aviso, setAviso] = useState(false);
    const [message, setMessage] = useState(null);

    const perfil = storage.get('perfilid');
    const usuario = storage.get('id');
    const toast = useRef(null);

    useEffect(() => {
        if (![1, 5, 9, 10, 11, 12, 19].includes(parseInt(perfil))) {
            return navigate('/login');
        }
    }, [perfil]);

    let url = `${BASE_API}Usuarios/SpdCrudCicloEscolar`;

    useEffect(() => {
        setLoading(true);
        const date = new Date();
        helpHttp().post(url, {
            body: {
                "Opcion": "S",
                "IdCicloEscolar": null,
                "IdPerfil": perfil,
                "IdUsuario": usuario,
                "DescripcionCicloEscolar": "",
                "Activo": null,
                "FechaInicioCiclo": date.toISOString(),
                "FechaFinCiclo": date.toISOString(),
                "EntregaKit": null,
                "TextoCiclo": "",
                "VigenciaCiclo": "",
                "LimitePrendas": null,
                "HabilitarEntregaParcial": null,
                "Evento": null,
                "Visible": null
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.SUCCESS) {
                let jsonCiclos = [];
                jsonCiclos = res.ITEMS;

                if (jsonCiclos.length > 0) {

                    setUsuarios(jsonCiclos);
                    initFilters1();
                } else {
                    setUsuarios(null);
                }

            }
            setLoading(false);
        });
    }, [url]);

    const borrarCiclo = async (rowData) => {
        setLoadingBorrado(true)
        helpHttp().post(`${BASE_API}Usuarios/SpdCrudCicloEscolar`, {
            body: {
                "Opcion": "B",
                "IdCicloEscolar": rowData.IdCicloEscolar,
                "IdPerfil": perfil,
                "IdUsuario": usuario,
                "DescripcionCicloEscolar": rowData.Descripcion,
                "Activo": rowData.Activo,
                "FechaInicioCiclo": rowData.FechaIni,
                "FechaFinCiclo": rowData.FechaFin,
                "EntregaKit": rowData.EntregaKit,
                "TextoCiclo": rowData.TextoCiclo,
                "VigenciaCiclo": rowData.Vigencia,
                "LimitePrendas": rowData.LimitePrendas,
                "HabilitarEntregaParcial": rowData.HabilitarEntregaParcial,
                "Evento": rowData.Evento,
                "Visible": rowData.Visible,
                "prendas": rowData.prenda,
                "proceso": rowData.proceso,
                "documentos": rowData.tipoDocumento
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(async (res) => {
            if (res.SUCCESS) {
                const consulta = await obtenerCiclo(rowData.IdCicloEscolar, 2);
                setUsuarios(consulta)
                toast.current.show({ severity: 'success', summary: "Éxito", detail: 'Borrado correctamente.', life: 5000 });
                onHideAviso();
            } else {
                toast.current.show({ severity: 'warn', summary: "Aviso.", detail: 'Error de conexión. Intente de nuevo.', life: 5000 })
            }
            setLoadingBorrado(false)
        });
    }

    const showUltimaModificacion = (rowData) => {
        let fechaModificacion = rowData.FechaUltimaModificacion !== null ? new Date(rowData.FechaUltimaModificacion) : null;
        return <label>{rowData.FechaUltimaModificacion !== null ? fechaModificacion.toLocaleDateString('en-GB') : " - "}</label>
    }

    const showStatus = (rowData) => {
        return (
            <>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Tooltip target=".custom-target-icon" />
                    <div className='custom-target-icon flex' data-pr-tooltip={rowData.Activo == true ? 'Desactivar' : 'Activar'} data-pr-position='top'>
                        <InputSwitch id='estilodeSwitc' checked={rowData.Activo} onChange={(e) => handleChamge_switch(rowData)} />
                    </div>
                    <div>
                        <button type="button" className="p-button p-component p-button-text p-button-icon-only" style={{ paddingTop: 0 }} onClick={(e) => handleChamge_form_edit(rowData)}>
                            <span className={`p-button-icon p-c pi pi-pencil custom-target-icon`} data-pr-tooltip='Editar' data-pr-position='top'></span>
                            <span className="p-button-label p-c">&nbsp;</span>
                            <span className="p-ink"></span>
                        </button>
                    </div>
                    <div>
                        <button type="button" className="p-button p-component p-button-text p-button-icon-only" style={{ paddingTop: 0 }} onClick={() => openDialogAviso(rowData)}>
                            <span className={`p-button-icon p-c pi pi-trash custom-target-icon`} data-pr-tooltip='Borrar' data-pr-position='top'></span>
                            <span className="p-button-label p-c">&nbsp;</span>
                            <span className="p-ink"></span>
                        </button>
                    </div>
                </div>


            </>
        );
    }

    const obtenerCiclo = async (IdCicloEscolar, opcion) => {
        let ciclos = []
        const date = new Date();
        ciclos = await helpHttp().post(url, {
            body: {
                "Opcion": "S",
                "IdCicloEscolar": null,
                "IdPerfil": perfil,
                "IdUsuario": usuario,
                "DescripcionCicloEscolar": "",
                "Activo": null,
                "FechaInicioCiclo": date.toISOString(),
                "FechaFinCiclo": date.toISOString(),
                "EntregaKit": null,
                "TextoCiclo": "",
                "VigenciaCiclo": "",
                "LimitePrendas": null,
                "HabilitarEntregaParcial": null,
                "Evento": null,
                "Visible": null
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => res.ITEMS);

        let ciclo
        switch (opcion) {
            case 1:
                ciclo = ciclos.find(x => x.IdCicloEscolar === IdCicloEscolar);
                break;
            case 2:
                ciclo = ciclos.filter(x => x.IdCicloEscolar !== IdCicloEscolar);
                break;
        }

        return ciclo;
    }

    const handleChamge_switch = (rowData) => {
        setLoadingSubmit({ loading: true, id: rowData.IdCicloEscolar });
        const date = new Date();
        helpHttp().post(`${BASE_API}Usuarios/SpdCrudCicloEscolar`, {
            body: {
                "Opcion": "M",
                "IdCicloEscolar": rowData.IdCicloEscolar,
                "IdPerfil": perfil,
                "IdUsuario": usuario,
                "DescripcionCicloEscolar": rowData.Descripcion,
                "Activo": !rowData.Activo,
                "FechaInicioCiclo": rowData.FechaIni,
                "FechaFinCiclo": rowData.FechaFin,
                "EntregaKit": rowData.EntregaKit,
                "TextoCiclo": rowData.TextoCiclo,
                "VigenciaCiclo": rowData.Vigencia,
                "LimitePrendas": rowData.LimitePrendas,
                "HabilitarEntregaParcial": rowData.HabilitarEntregaParcial,
                "Evento": rowData.Evento,
                "Visible": rowData.Visible,
                "prendas": rowData.prenda,
                "proceso": rowData.proceso,
                "documentos": rowData.tipoDocumento
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(async (res) => {
            if (res.SUCCESS) {
                const consulta = await obtenerCiclo(rowData.IdCicloEscolar, 1)

                onComponentUpdate(consulta);
            }
        });
    }

    const handleChamge_form_edit = (rowData) => {
        setUser(rowData);
        setEditModal(true)
    }

    const handleChamge_close_modal = () => {
        setUser(null);
        setEditModal(false);
    }

    const onComponentUpdate = (updateData) => {
        let newData = getUsuarios.map((el) =>
            (el.IdCicloEscolar === updateData.IdCicloEscolar ? updateData : el)
        );
        setUsuarios(newData);
    }

    const showInicioFinCiclo = (rowData) => {
        let fechaInicioCiclo = new Date(rowData.FechaIni)
        let fechaFinCiclo = new Date(rowData.FechaFin)

        return <label>{fechaInicioCiclo.toLocaleDateString('en-GB')} - {fechaFinCiclo.toLocaleDateString('en-GB')}</label>
    }


      const showProceso = (rowData) => {

        let proceso = JSON.parse(rowData.proceso)

        return <label style={{textTransform: 'uppercase'}}>{proceso[0].proceso}</label>

    }


    const onGlobalFilterChange1 = (e) => {
        const value = e.target.value;

        let _filters1 = { ...filters1 };
        _filters1['global'].value = value;

        setFilters1(_filters1);
        setGlobalFilterValue1(value);
    }

    const renderHeader1 = () => {
        return (
            <div className='col-12'>
                <span className="p-input-icon-left w-full">
                    <i className="pi pi-search" />
                    <InputText className='w-full' value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Búsqueda general" />
                </span>
                {/* <Button type="button" label="Limpiar" className="p-button-outlined" onClick={clearFilter1} /> */}
            </div>
        )
    }

    const dialogAvisoFooter = () => {
        return <React.Fragment>
            <Button className='p-button' loading={loadingBorrado} outlined label='NO' icon='pi pi-times' onClick={() => onHideAviso()} />
            <Button className='p-button' loading={loadingBorrado} label='SÍ' icon='pi pi-check' onClick={() => borrarCiclo(message)} />
        </React.Fragment>
    }

    const initFilters1 = () => {
        setFilters1({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
            'Descripcion': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        });
        setGlobalFilterValue1('');
    }

    const clearFilter1 = () => {
        initFilters1();
    }

    const openDialogAviso = (rowData) => {
        setMessage(rowData);
        setAviso(!aviso)
    }

    const onHideAviso = () => {
        setAviso(!aviso);
        setMessage(null)
    }

    const header1 = renderHeader1();

    const rightToolbarTemplate = () => {
        return (<Button label="Nuevo usuario" icon="pi pi-plus" className="p-button-success mr-2" onClick={() => navigate('/configuracion/ciclo/crear')} />)
    }

    const statuses = [
        'unqualified', 'qualified', 'new', 'negotiation', 'renewal', 'proposal'
    ];

    const statusFilterTemplate = (options) => {
        return <Dropdown value={options.value} options={statuses} onChange={(e) => options.filterCallback(e.value, options.index)} itemTemplate={statusItemTemplate} placeholder="Select a Status" className="p-column-filter" showClear />;
    }

    const statusItemTemplate = (option) => {
        return <span className={`customer-badge status-${option}`}>{option}</span>;
    }

    const basicDialogFooter = <Button type="button" label="Aceptar" onClick={() => setDisplayBasic(false)} icon="pi pi-check" className="p-button-secondary" />;

    
    return (
        <>
            <div>
                <Menu link='filtro' />
                <Toast ref={toast} />
                <div className="col-12">
                    <div className="card">
                        <h4 style={{ textAlign: 'center', marginTop: '10px' }}>CICLOS ESCOLARES</h4>
                        <div className='col-12 flex' style={{ marginBottom: '10px' }}>
                            <div className='col-6 text-left' style={{ alignSelf: 'center' }}>
                                <label style={{ fontSize: '14px' }}>Total <label style={{ fontWeight: '600' }}>{(getUsuarios?.length > 0 ? getUsuarios?.length : 0)}</label></label>
                            </div>
                            <div className='col-6 text-right'>
                                <Button label="Nuevo ciclo" icon="pi pi-plus" className="p-button-success mr-2" style={{ background: '#9b2f3e', border: 'none' }} onClick={() => navigate('/configuracion/ciclo/crear')} />
                            </div>

                        </div>

                        <DataTable
                            value={getUsuarios}
                            className="p-datatable-gridlines"
                            rows={50}
                            showGridlines
                            paginator
                            filterDisplay="menu"
                            dataKey="IdCicloEscolar"
                            loading={loading}
                            responsiveLayout="scroll"
                            emptyMessage="No se encontraron usuarios."
                            filters={filters1}
                            header={header1}>

                            <Column header="Ciclo" field="Descripcion" style={{ fontWeight: '' }}/>
                            <Column header="Proceso" body={showProceso} style={{ fontWeight: '700'}} />
                            <Column header="Inicio - Fin" body={showInicioFinCiclo} />
                            <Column header="Fecha última modificación" field="TipoUsuario" body={showUltimaModificacion} />
                            <Column
                                header="Acciones"
                                body={showStatus}
                                style={{ textAlign: "center", minWidth: '5rem' }}
                                filterElement={statusFilterTemplate}
                            />
                        </DataTable>
                    </div>
                </div>
            </div>

            <EditCiclo visible={getEditModal} user={getUser} close={handleChamge_close_modal} onComponentUpdate={onComponentUpdate} />

            <Dialog header="CONFIRMACIÓN" visible={aviso} onHide={onHideAviso} style={{ width: '400px' }} modal className="p-fluid text-center" footer={dialogAvisoFooter}>
                {message !== null &&
                    <div className='m-4'>
                        <label>¿Está seguro de eliminar el ciclo <strong>{message.Descripcion}</strong>? </label><br />
                    </div>
                }
            </Dialog>

        </>
    );
}

export default ListaCiclos;